import { LOGO } from "../assets/images";

const APP_NAME = "Sad Grey Building";
const APP_PRIMARY_COLOR = "#808080";
const APP_SLOGAN = "Because Ctrl+C, Ctrl+V Got Old";
const APP_LOGO = LOGO;

const SORT_DIRECTIONS = {
  ASCENDING: "ASC",
  DESCENDING: "DESC",
};

const DISPLAY_PER_PAGE = 25;

const ROLES = [
  { label: "System Administrator", value: 1 },
  { label: "Generator", value: 2 },
];

const ROLE_NAMES = {
  SYS_ADMIN: "System Administrator",
  GENERATOR: "Generator",
};

const DOMAINS = [
  { label: "Admin", value: "Admin" },
  { label: "User", value: "User" },
];

const NOTIFICATION_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
};

const VARIABLE_TYPES = [
  { label: "String", value: 0 },
  { label: "Ansistring", value: 1 },
  { label: "DateTime", value: 2 },
  { label: "DateTime2", value: 3 },
  { label: "Date", value: 4 },
  { label: "Guid", value: 5 },
  { label: "Boolean", value: 6 },
  { label: "Byte", value: 7 },
  { label: "Int16", value: 8 },
  { label: "Int32", value: 9 },
  { label: "Int64", value: 10 },
  { label: "Binary", value: 11 },
  { label: "Decimal", value: 12 },
  { label: "Float", value: 13 },
  { label: "Double", value: 14 },
];

const constants = {
  APP_NAME,
  APP_SLOGAN,
  APP_PRIMARY_COLOR,
  APP_LOGO,
  DISPLAY_PER_PAGE,
  NOTIFICATION_TYPES,
  SORT_DIRECTIONS,
  ROLES,
  ROLE_NAMES,
  VARIABLE_TYPES,
  DOMAINS,
};

export default constants;
